const patternString = `^(?=.{4,9}$)[A-ZÄÖÜ]{1,3}-[A-ZÄÖÜ]{1,2}\\d{1,4}[A-Z]?$`;
export const licenseNumberPattern = new RegExp(patternString, 'u');

export const vinPattern = /^[A-HJ-NPR-Z0-9]{17}$/;
export const zipCodeRegex = /^(D-)?[0-9]{5}$/;
